
<template>
  <div class="test">
  </div>
</template>
<script>
  import { VueCropper } from 'vue-cropper'
  export default {
    name:'testtt',
    data(){
      return{
      }
    },
    components: {
    },
    methods: {
    },
  }
</script>
<style lang="less">
  .test{
    height: 900px;
    .vue-cropper{
      height: 600px;
    }
    .el-slider__runway{
      font-size: 12px!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/test111/test.vue